import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image } from 'components/core/Image';
import { H3, Paragraph } from 'components/core/Typography';
import { PSPMarkdownContent } from 'components/psp/PSPMarkdown';
import './PSPUnitCards.scss';
import ScrollWrapper from 'components/molecules/ScrollWrapper/ScrollWrapper';
function separateStringFirstSpace(str) {
	const stringSpaceIndex = str.indexOf(' ');
	const stringBeforeSpace = str.substring(0, stringSpaceIndex);
	const stringAfterSpace = str.substring(stringSpaceIndex + 1);
	return [stringBeforeSpace, stringAfterSpace];
}
const separateStringWithSQSpace = (str) => {
	const splittedString = str.split('SQ');
	return [splittedString[0], 'SQ' + splittedString[1]];
};

export default function PSPUnitCards({
	unitCards,
	scrollable,
	linkUrl,
	linkText,
	slug,
	scrollFactor = 1,
	pageType,
}) {
	return (
		<ScrollWrapper
			className={`PSPMarkdownContent ${slug}`}
			scrollFactor={scrollFactor}
			slug={`psp-unit-cards-arrangement ${slug}`}
			config={{
				linkUrl,
				linkText,
			}}
			scrollable={scrollable}
		>
			{unitCards.map((unitCard) => {
				const [firsStringInfoTag, restOfStringInfoTag] =
					pageType === 'SGP'
						? separateStringWithSQSpace(unitCard.infoTag || '')
						: separateStringFirstSpace(unitCard.infoTag || '');
				return (
					<div
						key={unitCard.title}
						itemID={unitCard.title}
						className={classnames('psp-unit-cards-container', {
							'full-space': unitCard.layout,
							'plain-space': unitCard.plain,
						})}
					>
						<div className="container-image">
							<Image
								src={unitCard.image}
								alt="psp-unit-cards-image"
								className="psp-unit-cards-image"
								lazyLoad={false}
							/>
						</div>
						<div
							className={classnames(
								'psp-unit-cards-head-content',
								{
									'align-head-content-half-size':
										!unitCard.layout,
								},
							)}
						>
							{unitCard.title && (
								<H3
									size="semiLarge"
									weight="ultraBold"
									last
								>
									{unitCard.title}
								</H3>
							)}
							{unitCard.infoTag && (
								<div className="psp-unit-cards-info-tag">
									<Paragraph
										className="space-info-tag"
										size="standard"
										weight="bold"
									>
										{firsStringInfoTag}
									</Paragraph>
									<Paragraph
										className="space-info-tag"
										size="standard"
										weight="standard"
									>
										&nbsp;{restOfStringInfoTag}
									</Paragraph>
								</div>
							)}
						</div>
						<div className="psp-unit-cards-content">
							<PSPMarkdownContent content={unitCard.content} />
						</div>
					</div>
				);
			})}
		</ScrollWrapper>
	);
}

PSPUnitCards.propTypes = {
	unitCards: PropTypes.arrayOf(PropTypes.object).isRequired,
	linkUrl: PropTypes.string,
	linkText: PropTypes.string,
	slug: PropTypes.string,
	scrollFactor: PropTypes.number,
	scrollable: PropTypes.bool,
	pageType: PropTypes.string,
};

